export class FiltersToggle
{
  constructor(public bodyElement: any)
  {
    let filtersTrigger = document.getElementById('filters-toggle');
    let filtersContainer = document.getElementById('filters-container');

    if (filtersTrigger) {
      filtersTrigger.addEventListener('click', (e) =>
      {
        e.preventDefault();
        filtersContainer.classList.toggle('opened');
      });
    }
  }
}


// WEBPACK FOOTER //
// ./Static/javascript/modules/Filters-toggle.ts